import {useMemo} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {EnumItem, LocalizedEnumItem} from "../types/enumItem";

/**
 * For a given list of Localized Enum Items provides Enum Items with labels translated to users-selected language
 */
export const useLocalizedEnumItems = (localizedEnumItems: LocalizedEnumItem[]) => {
    const {t} = useTranslation();

    return useMemo(() => {
        const items: EnumItem[] = localizedEnumItems.map((item) => ({
            id: item.id,
            label: t(item.i18nKey),
        }));

        return {
            items,
            itemsById: _.keyBy(items, "id"),
        };
    }, [t, localizedEnumItems]);
};
